import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FieldAnswerFeedback } from '../../../ui/field-answer-feedback/field-answer-feedback';
import { NumberInputFieldWUT } from '../../../ui/number-input-field';
export const QuizNumberWUT = props => {
  const {
    target,
    externalData
  } = props;
  return /*#__PURE__*/React.createElement(NumberInputFieldWUT, _extends({}, props, {
    fieldType: FIELD_TYPES.QUIZ_NUMBER,
    required: false,
    hidden: false,
    additionalInfo: /*#__PURE__*/React.createElement(FieldAnswerFeedback, {
      target: target,
      externalData: externalData
    })
  }));
};
//# sourceMappingURL=quiz-number-wut.js.map